module.exports = __webpack_public_path__ + "static/elephantTrunk-logo.fb6b325e.svg";